/** 用户与会员默认展示（未加载到接口数据时的占位） */
export const defaultUserProfile = {
  username: '管理员',
  email: 'admin@mazhizuo.com',
  member: {
    isVip: true,
    levelName: '中级版',
    levelKey: 'middle',
    expireDate: '2027-03-30',
    logoRemoved: true
  },
  features: {
    aiBeautify: false,
    aiBeautifyVisible: false,
    aiBeautifyShowAll: false,
    aiBeautifyMaxPerQr: 0,
    aiBeautifyDenyMessage: '',
    aiBeautifyReason: ''
  }
}

export function getDaysUntilExpire(dateStr) {
  if (!dateStr) return null
  const end = new Date(`${dateStr}T23:59:59`)
  if (isNaN(end.getTime())) return null
  const diff = end.getTime() - Date.now()
  return Math.max(0, Math.ceil(diff / (86400000)))
}

export function formatExpireDisplay(dateStr) {
  if (!dateStr) return '无期限'
  return dateStr
}

export function getMemberRemainText(days) {
  if (days === null || days === undefined) return '长期有效'
  if (days === 0) return '今日到期'
  if (days <= 30) return `剩余 ${days} 天`
  return `剩余 ${days} 天`
}

export function isMemberExpiringSoon(days) {
  return days !== null && days <= 30
}
